import React from 'react';
import { connect } from 'react-redux';
import ActualizacionMasivaPrecioYStock from './ActualizacionMasivaPrecioYStock';
import ActualizacionMasivaTipoYEnvio from './ActualizacionMasivaTipoYEnvio';
import CargaMasivaImagenesExcel from './CargaMasivaImagenesExcel';

const ActualizacionMasivaPublicaciones = ({ idSeller, userType, idUsuario }) => {
    const isSeller = userType.isSeller || userType.isSellerAdmin;
    const isAdmin = userType.isCategory || userType.isAdminMod;
    const cardSize = isAdmin ? "col-12 col-xxl-5" : "col-12";

    return (
        <div className="container">
            <div className="row justify-content-around page-titles text-center text-md-start">

                <div className="col-12 mb-4">
                    <div className="row mb-2 pb-2">

                        <div className="col-12 col-md-auto align-self-center">
                            <h4 className="text-themecolor color-rojo-megatone">Actualización Masiva</h4>
                        </div>

                        <div className="col-12 p-0 ps-1 border-2 border-start d-inline-flex">
                            <div className="row">
                                <label>Presione el botón Formato Excel para descargar un excel con el formato correcto, luego completelo y vuelva a importarlo.</label>
                                <label>O bien desde el menú Publicaciones, aplique un Filtro y exporte a Excel, actualice los datos y vuelva a Importarlo.</label>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="row gy-1 gx-3">
                    <div className={cardSize}>
                        <ActualizacionMasivaPrecioYStock
                            idSeller={idSeller}
                            userType={userType}
                            idUsuario={idUsuario}
                        />
                    </div>

                    {(isAdmin || isSeller) && (
                        <div className={cardSize}>
                            <ActualizacionMasivaTipoYEnvio />
                        </div>
                    )}

                    <div className={cardSize}>
                        <CargaMasivaImagenesExcel
                            idSeller={idSeller}
                            userType={userType}
                            idUsuario={idUsuario}
                        />
                    </div>
                </div>

            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    idSeller: state.general.idSeller,
    userType: state.general.userType,
    idUsuario: state.general.userId,
});

export default connect(mapStateToProps)(ActualizacionMasivaPublicaciones);